import { useState, useEffect } from "react";
import { getFooterData } from "../../sanityClient";

// import style
import "../../style/pages/layout/footer.scss";

const Footer = () => {
  const [footerData, setFooterData] = useState({
    askButtonText: "Ask Ben-Sensei a Question!",
    askButtonJapaneseText: "英語について質問したい方はこちら",
    askButtonLink: "/question",
    contactButtonText: "Contact Us",
    contactButtonJapaneseText: "お問い合わせ",
    contactButtonLink: "/contact",
    backgroundColorClass: "background-green"
  });

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const data = await getFooterData();
        if (data) {
          setFooterData(prevData => ({
            askButtonText: data.askButtonText || prevData.askButtonText,
            askButtonJapaneseText: data.askButtonJapaneseText || prevData.askButtonJapaneseText,
            askButtonLink: data.askButtonLink || prevData.askButtonLink,
            contactButtonText: data.contactButtonText || prevData.contactButtonText,
            contactButtonJapaneseText: data.contactButtonJapaneseText || prevData.contactButtonJapaneseText,
            contactButtonLink: data.contactButtonLink || prevData.contactButtonLink,
            backgroundColorClass: data.backgroundColorClass || prevData.backgroundColorClass
          }));
        }
      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    };
  
    fetchFooterData();
  }, []);

  return (
    <div className={`footer-section ${footerData.backgroundColorClass}`}>
      <div className="footer-main">
        <div className="item">
          <a href={footerData.askButtonLink} className="footer-btn font-amaticsc-bold">
            {footerData.askButtonText}
            <span className="btn-text font-kleeone">
              {footerData.askButtonJapaneseText}
            </span>
          </a>
        </div>
        <div className="item">
          <a href={footerData.contactButtonLink} className="footer-btn font-amaticsc-bold">
            {footerData.contactButtonText}
            <span className="btn-text font-kleeone">{footerData.contactButtonJapaneseText}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
